import mediaUploader from "../mediaUploader/mediaUploader.vue";
import { PREPARE_TOUR_TYPE_REGIONAL } from "../../../util/enumTypes";

import download from "../../../util/download";

export default {
  components: {
    mediaUploader,
    modal: () => import(/* webpackChunkName: "modal" */ "../modal/modal.vue")
  },
  props: {
    banners: {
      type: Array,
      default: []
    },
    tourTariffs: {
      type: Array,
      default: []
    },
    tourTariffAssociatedOrder: Array
  },
  data() {
    return {
      formFilter: {
        pdf: 0,
        banner: 0,
        search: ""
      },
      banner: "banner",
      pdf: "pdf",
      urlImg: "",
      currentPage: 1,
      pageSize: 15,
      showRelatedTariffOrder: false,
      relatedTourNumber: 0
    };
  },
  computed: {
    tableData() {
      let result = [];
      this.banners.forEach(b => {
        if (this.filtered(b)) {
          result.push({
            tourId: b.id,
            tourType:
              b.type == PREPARE_TOUR_TYPE_REGIONAL
                ? this.$t("prepare_tour_admin_type_reg")
                : this.$t("prepare_tour_admin_type_fix"),
            tourTypeOriginal: b.type,
            tourName: b.title,
            pdfFileName: b.description ? b.description.fileName : "",
            pdfFileUrl: b.description ? [b.description.url] : [],
            pdfFileDescription: b.description ? b.description.description : "",
            pdfFileUpdated: b.description ? b.description.updated : "",
            bannerFileName: b.bannerFile ? b.bannerFile.fileName : "",
            bannerFileUrl: b.bannerFile ? [b.bannerFile.url] : [],
            bannerFileDescription: b.bannerFile ? b.bannerFile.description : "",
            bannerFileUpdated: b.bannerFile ? b.bannerFile.updated : ""
          });
        }
      });
      return result;
    },
    paginationData() {
      let start = (this.currentPage - 1) * this.pageSize;
      let end = start + this.pageSize;
      if (this.tableData.length < start + 1) {
        this.currentPage = 1;
        return this.tableData;
      } else {
        return this.tableData.slice(start, end);
      }
    },
    pdfOptions() {
      return [
        { value: 0, label: this.$t("prepare_tour_admin_filter_option_all") },
        { value: 1, label: this.$t("prepare_tour_admin_filter_option_pdf") },
        { value: 2, label: this.$t("prepare_tour_admin_filter_option_non_pdf") }
      ];
    },
    bannerOptions() {
      return [
        { value: 0, label: this.$t("prepare_tour_admin_filter_option_all") },
        { value: 1, label: this.$t("prepare_tour_admin_filter_option_banner") },
        {
          value: 2,
          label: this.$t("prepare_tour_admin_filter_option_non_banner")
        }
      ];
    },
    totalItems() {
      return this.tableData.length;
    }
  },
  methods: {
    getUploaderName(row, type) {
      return type == this.banner
        ? `bannerUpload_${row.tourId}`
        : `pdfUpload_${row.tourId}`;
    },
    getLastParam(fileUrl) {
      if (!fileUrl) {
        return false;
      }

      let d = fileUrl.split("/");
      return d[d.length - 1];
    },
    allUploaded(row, type) {
      let tour = this.tableData.filter(b => b.tourId === row.tourId);
      if (tour.length) {
        let url =
          type == this.banner
            ? tour[0].bannerFileUrl[0]
            : tour[0].pdfFileUrl[0];
        console.log("allUploaded", tour, url, this.getLastParam(url));
        this.$emit("saveRelation", {
          prepareTourId: tour[0].tourId,
          fileId: this.getLastParam(url)
        });
      }
    },
    showImg(url, type, fileName) {
      if (type == this.banner) {
        this.urlImg = url;
      } else {
        download.getPDFByURL(url, fileName);
      }
    },
    modalClose() {
      this.urlImg = "";
      this.showRelatedTariffOrder = false;
      this.$emit("closeModal");
    },
    deleteRelation(url) {
      let fileId = this.getLastParam(url);
      this.$emit("deleteRelation", fileId);
    },
    filtered(banner) {
      if (this.formFilter.pdf > 0) {
        if (this.formFilter.pdf == 1 && !banner.description) {
          return false;
        }
        if (this.formFilter.pdf == 2 && banner.description) {
          return false;
        }
      }

      if (this.formFilter.banner > 0) {
        if (this.formFilter.banner == 1 && !banner.bannerFile) {
          return false;
        }
        if (this.formFilter.banner == 2 && banner.bannerFile) {
          return false;
        }
      }

      if (this.formFilter.search && this.formFilter.search.length > 2) {
        let a = banner.title.toLowerCase();
        let b = (banner.type == PREPARE_TOUR_TYPE_REGIONAL
          ? this.$t("prepare_tour_admin_type_reg")
          : this.$t("prepare_tour_admin_type_fix")
        ).toLowerCase();
        let x = this.formFilter.search.toLowerCase();
        if (a.indexOf(x) == -1 && b.indexOf(x) == -1) {
          return false;
        }
      }

      return true;
    },
    handleCurrentChange(val) {
      this.currentPage = val;
    },
    isRegional(tourType) {
      return tourType == PREPARE_TOUR_TYPE_REGIONAL;
    },
    fixTourClick(tourId) {
      this.relatedTourNumber = tourId;
      this.$emit("fixTourClick", this.relatedTourNumber);
      this.showRelatedTariffOrder = true;
    },
    changeModalSaveRelatedTariffOrder() {
      this.disabledModalSaveRelated = !this.tourTariffs.some(
        t => t.orderNumber != t.originOrderNumber
      );
    },
    modalSaveRelatedTariffOrder() {
      let isChange = false;
      let result = {
        tariffOrder: []
      };
      this.tourTariffs.forEach(t => {
        if (t.orderNumber != t.originOrderNumber) {
          result.tariffOrder.push({
            tariffId: t.tariffId,
            orderNumber: t.orderNumber
          });
          isChange = true;
        }
      });

      this.relatedClearAllMessages();

      if (isChange) {
        this.$emit("modalSaveRelatedTariffOrder", result);
      }
    },
    relatedClearAllMessages() {
      this.tourTariffs.forEach(t => {
        t.errorText = "";
        t.successText = "";
      });
    },
    updateErrorMessage() {
      this.tourTariffAssociatedOrder.forEach(r => {
        let tariffs = this.tourTariffs.filter(t => t.tariffId == r.tariffId);
        if (tariffs.length == 1) {
          let tariff = tariffs[0];
          if (r.error) {
            tariff.errorText = r.error;
          } else {
            tariff.successText = this.$t("prepare_tour_admin_related_success");
            tariff.originOrderNumber = r.orderNumber;
          }
        }
      });
    },
    tableRowClassName({ row, rowIndex }) {
      if (!row.show) {
        return {
          backgroundColor: "#E6A23C"
        };
      }
      return {};
    }
  },
  watch: {
    tourTariffAssociatedOrder: function () {
      if (
        this.tourTariffAssociatedOrder &&
        this.tourTariffAssociatedOrder.length &&
        this.showRelatedTariffOrder
      ) {
        this.updateErrorMessage();
      }
    }
  }
};
